import {
  Box,
  Button,
  Card,
  Container,
  Stack,
  Text,
  Title,
  Divider,
  ScrollArea,
  ActionIcon,
  Group,
  useMantineColorScheme,
} from "@mantine/core";
import { ArrowLeft } from "@phosphor-icons/react";


export default function TermsAndConditions() {
  const { colorScheme } = useMantineColorScheme();
  const textColor = colorScheme === "dark" ? "white" : "#393939";
  const headingColor = colorScheme === "dark" ? "white" : "#1D1D1D";

  return (
    <Box
      style={{
        minHeight: "100vh",
        background: `
        linear-gradient(0deg, #FAFAFA, #FAFAFA),
        linear-gradient(118.69deg, rgba(254, 136, 112, 0.075) 7.78%, rgba(157, 113, 132, 0.075) 50.78%, rgba(45, 86, 154, 0.075) 100%)
        `,
        padding: "24px 0",
      }}
    >
      <Container size="lg">
        <Stack align="center" gap={24}>
          {/* Logo */}
          <Box
            style={{
              width: 183,
              height: 40,
              background: "url(/assets/logo_main.png)",
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />

          {/* Main Content Card */}
          <Card
            shadow="sm"
            radius="md"
            style={{
              width: "100%",
              maxWidth: 821,
              backgroundColor: "#FFFFFF",
              boxShadow:
                "0px 1px 4px 0px rgba(12, 12, 13, 0.05), 0px 1px 4px 0px rgba(12, 12, 13, 0.1)",
            }}
            p={0}
          >
            <Stack gap={16} p="24px 40px 0">
              <Group justify="space-between" align="center" style={{ position: "relative", minHeight: 40 }}>
                <ActionIcon
                  size="lg"
                  variant="filled"
                  radius="md"
                  style={{
                    backgroundColor: "#FFFFFF",
                    color: "#1D1D1D",
                    boxShadow:
                      "0px 1px 4px 0px rgba(12, 12, 13, 0.05), 0px 1px 4px 0px rgba(12, 12, 13, 0.1)",
                    zIndex: 10,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  styles={{
                    root: {
                      "&:hover": {
                        backgroundColor: "#1D1D1D",
                        color: "#FFFFFF",
                      },
                    },
                  }}
                  onClick={() => window.close()}
                >
                  <ArrowLeft size={18} />
                </ActionIcon>
                <Title
                  order={2}
                  style={{
                    fontFamily: "SF Pro",
                    fontWeight: 510,
                    fontSize: 20,
                    lineHeight: "1.2em",
                    textAlign: "center",
                    color: "#124B8C",
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "100%",
                    pointerEvents: "none",
                  }}
                >
                  Terms and Conditions
                </Title>
                <Box style={{ width: 40 }} />
              </Group>

              {/* Content */}
              <ScrollArea style={{ height: "calc(100vh - 200px)" }}>
                <Stack gap={24} style={{ paddingRight: "16px" }}>
                  {/* Last Updated and Description */}
                  <Stack gap={8}>
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        width: 226,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 14,
                          lineHeight: "1.2em",
                          color: "#979797",
                        }}
                      >
                        Last updated:
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: textColor,
                        }}
                      >
                        January 27, 2021
                      </Text>
                    </Box>
                    <Text
                      style={{
                        fontFamily: "SF Pro",
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: "1.2em",
                        color: textColor,
                      }}
                    >
                      Please read these terms and conditions carefully before
                      using Our Service.
                    </Text>
                  </Stack>

                  <Divider color="#E9E9E9" />

                  {/* Terms Content */}
                  <Stack gap={24}>
                    {/* 1. Interpretation and Definitions */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        1. Interpretation and Definitions
                      </Text>

                      <Stack gap={8}>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontWeight: 510,
                            fontSize: 16,
                            lineHeight: "1.2em",
                            color: headingColor,
                          }}
                        >
                          Interpretation
                          <br />
                          <br />
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: "1.6em",
                            color: textColor,
                          }}
                        >
                          The words of which the initial letter is capitalized
                          have meanings defined under the following conditions.
                          The following definitions shall have the same meaning
                          regardless of whether they appear in singular or in
                          plural.
                        </Text>
                      </Stack>

                      <Stack gap={12}>
                        <Stack gap={8}>
                          <Text
                            style={{
                              fontFamily: "SF Pro",
                              fontWeight: 510,
                              fontSize: 16,
                              lineHeight: "1.2em",
                              color: headingColor,
                            }}
                          >
                            Definitions
                            <br />
                            <br />
                          </Text>
                          <Text
                            style={{
                              fontFamily: "SF Pro",
                              fontWeight: 400,
                              fontSize: 14,
                              lineHeight: "1.2em",
                              color: textColor,
                            }}
                          >
                            For the purposes of these Terms and Conditions:
                          </Text>
                        </Stack>
                        <Stack gap={8}>
                          <Text
                            style={{
                              fontFamily: "SF Pro",
                              fontWeight: 400,
                              fontSize: 14,
                              lineHeight: "1.6em",
                              color: textColor,
                            }}
                          >
                            * Application means the software program provided by
                            the Company downloaded by You on any electronic
                            device, named Virtual Me
                            <br />
                            <br />
                            * Application Store means the digital distribution
                            service operated and developed by Apple Inc. (Apple
                            App Store) or Google Inc. (Google Play Store) in
                            which the Application has been downloaded.
                            <br />
                            <br />
                            * Affiliate means an entity that controls, is
                            controlled by or is under common control with a
                            party, where "control" means ownership of 50% or
                            more of the shares, equity interest or other
                            securities entitled to vote for election of
                            directors or other managing authority.
                            <br />
                            <br />
                            * Country refers to: Minnesota, United States
                            <br />
                            <br />
                            * Company (referred to as either "the Company",
                            "We", "Us" or "Our" in this Agreement) refers to
                            OneSelf LLC, 14355 McKenna Road NW, Prior Lake, MN,
                            55372.
                            <br />
                            <br />
                            * Device means any device that can access the
                            Service such as a computer, a cellphone or a digital
                            tablet.
                            <br />
                            <br />
                            * Service refers to the Application.
                            <br />
                            <br />
                            * Terms and Conditions (also referred as "Terms")
                            mean these Terms and Conditions that form the entire
                            agreement between You and the Company regarding the
                            use of the Service.
                            <br />
                            <br />
                            * Third-party Social Media Service means any
                            services or content (including data, information,
                            products or services) provided by a third-party that
                            may be displayed, included or made available by the
                            Service.
                            <br />
                            <br />
                            * You means the individual accessing or using the
                            Service, or the company, or other legal entity on
                            behalf of which such individual is accessing or
                            using the Service, as applicable.
                            <br />
                          </Text>
                        </Stack>
                      </Stack>
                    </Stack>

                    {/* Acknowledgment */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Acknowledgment
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        These are the Terms and Conditions governing the use of
                        this Service and the agreement that operates between You
                        and the Company. These Terms and Conditions set out the
                        rights and obligations of all users regarding the use of
                        the Service.
                        <br />
                        <br />
                        Your access to and use of the Service is conditioned on
                        Your acceptance of and compliance with these Terms and
                        Conditions. These Terms and Conditions apply to all
                        visitors, users and others who access or use the
                        Service.
                        <br />
                        <br />
                        By accessing or using the Service You agree to be bound
                        by these Terms and Conditions. If You disagree with any
                        part of these Terms and Conditions then You may not
                        access the Service.
                        <br />
                        <br />
                        You represent that you are over the age of 18. The
                        Company does not permit those under 18 to use the
                        Service.
                        <br />
                        <br />
                        Your access to and use of the Service is also
                        conditioned on Your acceptance of and compliance with
                        the Privacy Policy of the Company. Our Privacy Policy
                        describes Our policies and procedures on the collection,
                        use and disclosure of Your personal information when You
                        use the Application or the Website and tells You about
                        Your privacy rights and how the law protects You. Please
                        read Our Privacy Policy carefully before using Our
                        Service.
                      </Text>
                    </Stack>

                    {/* Intellectual Property */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Intellectual Property
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        The Service and its original content (excluding Content
                        provided by You or other users), features and
                        functionality are and will remain the exclusive property
                        of the Company and its licensors.
                        <br />
                        <br />
                        The Service is protected by copyright, trademark, and
                        other laws of both the Country and foreign countries.
                        <br />
                        <br />
                        Our trademarks and trade dress may not be used in
                        connection with any product or service without the prior
                        written consent of the Company.
                      </Text>
                    </Stack>

                    {/* Links to Other Websites */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Links to Other Websites
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        Our Service may contain links to third-party web sites
                        or services that are not owned or controlled by the
                        Company.
                        <br />
                        <br />
                        The Company has no control over, and assumes no
                        responsibility for, the content, privacy policies, or
                        practices of any third party web sites or services. You
                        further acknowledge and agree that the Company shall not
                        be responsible or liable, directly or indirectly, for
                        any damage or loss caused or alleged to be caused by or
                        in connection with the use of or reliance on any such
                        content, goods or services available on or through any
                        such web sites or services.
                        <br />
                        <br />
                        We strongly advise You to read the terms and conditions
                        and privacy policies of any third-party web sites or
                        services that You visit.
                      </Text>
                    </Stack>

                    {/* Termination */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Termination
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        We may terminate or suspend Your access immediately,
                        without prior notice or liability, for any reason
                        whatsoever, including without limitation if You breach
                        these Terms and Conditions.
                        <br />
                        <br />
                        Upon termination, Your right to use the Service will
                        cease immediately.
                      </Text>
                    </Stack>

                    {/* Limitation of Liability */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Limitation of Liability
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        Notwithstanding any damages that You might incur, the
                        entire liability of the Company and any of its suppliers
                        under any provision of this Terms and Your exclusive
                        remedy for all of the foregoing shall be limited to the
                        amount actually paid by You through the Service or 100
                        USD if You haven't purchased anything through the
                        Service.
                        <br />
                        <br />
                        To the maximum extent permitted by applicable law, in no
                        event shall the Company or its suppliers be liable for
                        any special, incidental, indirect, or consequential
                        damages whatsoever (including, but not limited to,
                        damages for loss of profits, loss of data or other
                        information, for business interruption, for personal
                        injury, loss of privacy arising out of or in any way
                        related to the use of or inability to use the Service,
                        third-party software and/or third- party hardware used
                        with the Service, or otherwise in connection with any
                        provision of this Terms), even if the Company or any
                        supplier has been advised of the possibility of such
                        damages and even if the remedy fails of its essential
                        purpose.
                        <br />
                        <br />
                        Some states do not allow the exclusion of implied
                        warranties or limitation of liability for incidental or
                        consequential damages, which means that some of the
                        above limitations may not apply. In these states, each
                        party's liability will be limited to the greatest extent
                        permitted by law.
                      </Text>
                    </Stack>

                    {/* "AS IS" Disclaimer */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        "AS IS" and "AS AVAILABLE" Disclaimer
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        The Service is provided to You "AS IS" and "AS
                        AVAILABLE" and with all faults and defects without
                        warranty of any kind. To the maximum extent permitted
                        under applicable law, the Company, on its own behalf and
                        on behalf of its Affiliates and its and their respective
                        licensors and service providers, expressly disclaims all
                        warranties, whether express, implied, statutory or
                        otherwise, with respect to the Service, including all
                        implied warranties of merchantability, fitness for a
                        particular purpose, title and non-infringement, and
                        warranties that may arise out of course of dealing,
                        course of performance, usage or trade practice. Without
                        limitation to the foregoing, the Company provides no
                        warranty or undertaking, and makes no representation of
                        any kind that the Service will meet Your requirements,
                        achieve any intended results, be compatible or work with
                        any other software, applications, systems or services,
                        operate without interruption, meet any performance or
                        reliability standards or be error free or that any
                        errors or defects can or will be corrected.
                        <br />
                        <br />
                        Without limiting the foregoing, neither the Company nor
                        any of the company's providers makes any representation
                        or warranty of any kind, express or implied: (i) as to
                        the operation or availability of the Service, or the
                        information, content, and materials or products included
                        thereon; (ii) that the Service will be uninterrupted or
                        error-free; (iii) as to the accuracy, reliability, or
                        currency of any information or content provided through
                        the Service; or (iv) that the Service, its servers, the
                        content, or e-mails sent from or on behalf of the
                        Company are free of viruses, scripts, trojan horses,
                        worms, malware, timebombs or other harmful components.
                        <br />
                        <br />
                        Some jurisdictions do not allow the exclusion of certain
                        types of warranties or limitations on applicable
                        statutory rights of a consumer, so some or all of the
                        above exclusions and limitations may not apply to You.
                        But in such a case the exclusions and limitations set
                        forth in this section shall be applied to the greatest
                        extent enforceable under applicable law.
                        <br />
                      </Text>
                    </Stack>

                    {/* Governing Law */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Governing Law
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        The laws of the Country, excluding its conflicts of law
                        rules, shall govern this Terms and Your use of the
                        Service. Your use of the Application may also be subject
                        to other local, state, national, or international laws.
                      </Text>
                    </Stack>

                    {/* Disputes Resolution */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Disputes Resolution
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        If You have any concern or dispute about the Service,
                        You agree to first try to resolve the dispute informally
                        by contacting the Company.
                      </Text>
                    </Stack>

                    {/* For European Union (EU) Users */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        For European Union (EU) Users
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        If You are a European Union consumer, you will benefit
                        from any mandatory provisions of the law of the country
                        in which you are resident in.
                      </Text>
                    </Stack>

                    {/* U.S. Legal Compliance */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        United States Legal Compliance
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        You represent and warrant that (i) You are not located
                        in a country that is subject to the United States
                        government embargo, or that has been designated by the
                        United States government as a "terrorist supporting"
                        country, and (ii) You are not listed on any United
                        States government list of prohibited or restricted
                        parties.
                      </Text>
                    </Stack>

                    {/* Severability & Waiver */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Severability and Waiver
                      </Text>
                      <Stack gap={8}>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontWeight: 510,
                            fontSize: 14,
                            lineHeight: "1.6em",
                            color: headingColor,
                          }}
                        >
                          Severability
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: "1.6em",
                            color: textColor,
                          }}
                        >
                          If any provision of these Terms is held to be
                          unenforceable or invalid, such provision will be
                          changed and interpreted to accomplish the objectives
                          of such provision to the greatest extent possible
                          under applicable law and the remaining provisions will
                          continue in full force and effect.
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontWeight: 510,
                            fontSize: 14,
                            lineHeight: "1.6em",
                            color: headingColor,
                          }}
                        >
                          Waiver
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: "1.6em",
                            color: textColor,
                          }}
                        >
                          Except as provided herein, the failure to exercise a
                          right or to require performance of an obligation under
                          this Terms shall not effect a party's ability to
                          exercise such right or require such performance at any
                          time thereafter nor shall be the waiver of a breach
                          constitute a waiver of any subsequent breach.
                        </Text>
                      </Stack>
                    </Stack>

                    {/* Translation Interpretation */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Translation Interpretation
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        These Terms and Conditions may have been translated if
                        We have made them available to You on our Service. You
                        agree that the original English text shall prevail in
                        the case of a dispute.
                      </Text>
                    </Stack>

                    {/* Changes to These Terms and Conditions */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Changes to These Terms and Conditions
                      </Text>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: "1.6em",
                          color: textColor,
                        }}
                      >
                        We reserve the right, at Our sole discretion, to modify
                        or replace these Terms at any time. If a revision is
                        material We will make reasonable efforts to provide at
                        least 30 days' notice prior to any new terms taking
                        effect. What constitutes a material change will be
                        determined at Our sole discretion.
                        <br />
                        <br />
                        By continuing to access or use Our Service after those
                        revisions become effective, You agree to be bound by the
                        revised terms. If You do not agree to the new terms, in
                        whole or in part, please stop using the website and the
                        Service.
                      </Text>
                    </Stack>

                    <Divider color="#E9E9E9" />

                    {/* Contact Us */}
                    <Stack gap={16}>
                      <Text
                        style={{
                          fontFamily: "SF Pro",
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: "1.2em",
                          color: headingColor,
                        }}
                      >
                        Contact Us
                      </Text>
                      <Stack gap={8}>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: "1.6em",
                            color: textColor,
                          }}
                        >
                          If you have any questions about these Terms and
                          Conditions, You can contact us:
                        </Text>
                        <Text
                          style={{
                            fontFamily: "SF Pro",
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: "1.6em",
                            color: textColor,
                          }}
                        >
                          * By email: contact@onselftechnology.com
                        </Text>
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              </ScrollArea>

              <Box style={{ display: "flex", justifyContent: "flex-start", padding: "24px 40px 24px 0px", marginLeft: "-40px", paddingLeft: "40px" }}>
                <Button
                  size="md"
                  style={{
                    backgroundColor: "#124B8C",
                    color: "white",
                    borderRadius: "8px",
                    padding: "7px 32px",
                    fontWeight: 500,
                    fontSize: "16px",
                    marginLeft: 0,
                  }}
                  onClick={() => {
                    if (window.opener) {
                      window.opener.postMessage({ type: 'AGREE_TERMS' }, '*');
                    }
                    window.close();
                  }}
                >
                  I Agree
                </Button>
              </Box>
            </Stack>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
}
